import { NgIf } from '@angular/common';
import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, FormControl } from '@angular/forms';
import { Host } from 'src/app/core/models/host.models';
import { MyUser } from '../../core/models/myUser.models';
import { AuthenticationService } from '../../core/services/auth.service';
import { Observable, combineLatest, EMPTY, Subject } from 'rxjs';
import { catchError, map, takeUntil } from 'rxjs/operators';
import { StorageService } from '../../core/services/storage.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss']
})
export class UserProfileComponent implements OnInit, OnDestroy {

  constructor(public activeModal: NgbActiveModal, private authService: AuthenticationService, private storageService: StorageService) { }

  @Input() user: MyUser;
  @Input() hosts: Host[];

  uploadProgress$: Observable<number>;
  submitted: boolean;
  fileToUpload: File;
  uploadPath: string;

  roles$: Observable<{host: Host, role: string}[]>;
  destroy$: Subject<null> = new Subject();

  profileForm: FormGroup = new FormGroup({
    displayName: new FormControl(null),
    avatar: new FormControl(null)
  })

  ngOnInit(): void {
    this.uploadPath = `users/${this.user.uid}`

    const temp = this.hosts?.length ? this.hosts?.map(host => {
      return this.authService.getUserRole(host.id).pipe(
        map(role => {
          return {
            role,
            host
          }
        })
      );
    }) : [];

    this.roles$ = combineLatest(temp);

    if (this.user.displayName) {
      this.profileForm.controls.displayName.setValue(this.user.displayName);
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
  }

  uploadAvatar() {
    if (this.fileToUpload) {
      this.postFile();
    }
  }

  saveUser() {
    if (this.user.displayName !== this.profileForm.value.displayName) {
      console.log('save');
      this.authService.setUserDisplayName(this.user.uid, this.profileForm.value.displayName);
      // user sessionben van tárolva, teljesen máshol íródik és van kiolvasva, ezért reload
      // window.location.reload();
    }
    this.activeModal.close();
  }

  fileSelected(files: File[]) {
    if (files?.length) {
      this.fileToUpload = files[0];
    } else {
      this.fileToUpload = null;
    }
  }

  private postFile() {
    this.submitted = true;
    const mediaFolderPath = `${ this.uploadPath }`;

    const { downloadUrl$, uploadProgress$ } = this.storageService.uploadFileAndGetMetadata(
      mediaFolderPath,
      this.fileToUpload,
      'avatar'
    );

    this.uploadProgress$ = uploadProgress$;

    downloadUrl$
      .pipe(
        takeUntil(this.destroy$),
        catchError((error) => {
          console.log('file error: ', error.message)
          // this.notificationService.openSnackBar('file hiba', 'error');
          return EMPTY;
        }),
      )
      .subscribe((downloadUrl) => {
        this.authService.setUserAvatar(this.user.uid, downloadUrl).then(() => {
          this.user.photoURL = downloadUrl;
        });
        this.submitted = false;
        // this.lastUploadedFile.emit({downloadUrl, filename: this.fileToUpload.name, path: mediaFolderPath, description: this.fileForm.value.description});
        this.profileForm.controls.avatar.reset();
        this.uploadProgress$ = null;
        // this.router.navigate([ `/${ FEED }` ]);
      });
  }

}
